export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgPlus = require("../assets/plus.png");
export const imgDelete = require("../assets/delete.png");
